/* ====================================================================
   Oduree - Cart Drawer (brandbook 2026)
   ====================================================================
   Open/close logic, AJAX add-to-cart interceptor, qty/remove acties,
   section-refresh via Shopify Section Rendering API.

   Events die de drawer luistert:
     - cart:open     open drawer
     - cart:refresh  herlaad inhoud + update badge
     - cart:update   alias van cart:refresh

   Exposes:  window.CartDrawer  (global helper)
   ==================================================================== */
(function () {
  "use strict";

  if (window.CartDrawer && window.CartDrawer._initialized) return;

  var SECTION_ID = "cart-drawer";
  var CART_T = window.ODUREE_CART_TRANSLATIONS || (window.ODUREE_T && window.ODUREE_T.cartDrawer) || {};
  var BASE_FREE_SHIPPING_THRESHOLD_CENTS = 4500;

  function getPresentmentRate() {
    var currency = window.Shopify && window.Shopify.currency;
    if (!currency || currency.active === "EUR") return 1;
    var rate = parseFloat(currency.rate);
    return isFinite(rate) && rate > 0 ? rate : 1;
  }

  function toPresentmentCents(baseCurrencyCents) {
    return Math.round((parseInt(baseCurrencyCents, 10) || 0) * getPresentmentRate());
  }

  // --------------------------------------------------------------------
  // Runtime cache van /products/{milestone.productHandle}.js voor
  // milestones met een product-thumbnail. Map per
  // handle -> featured_image URL. Voorkomt hardcoded CDN-paths die
  // breken als de admin de afbeelding her-uploadt.
  var _giftImageCache = {};

  // --------------------------------------------------------------------
  // MILESTONES configuratie (reward-bar + cadeautje-paneel)
  // --------------------------------------------------------------------
  // Gift tiers komen uit section blocks in de theme customizer. De fallback
  // blijft alleen gratis verzending tonen als er nog geen gift blocks staan.
  var GIFT_TIERS = [];
  var PAUSED_GIFT_HANDLES = ["signature-paraplu"];
  var FALLBACK_MILESTONES = [
    {
      key: "m2",
      threshold: toPresentmentCents(BASE_FREE_SHIPPING_THRESHOLD_CENTS),
      label: CART_T.freeShippingLabel || "Free shipping",
      desc: CART_T.freeShippingDesc || "Reach this amount for free shipping.",
      nextRewardLabel: CART_T.freeShippingNext || "free shipping",
      type: "shipping",
    },
  ];
  var MILESTONES = FALLBACK_MILESTONES.slice();

  function formatWithShopifyMoneyFormat(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split(".");
    var euros = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    var eurosComma = euros.replace(/\./g, " ");
    var replacements = {
      amount: euros + "," + parts[1],
      amount_no_decimals: euros,
      amount_with_comma_separator: euros + "," + parts[1],
      amount_no_decimals_with_comma_separator: euros,
      amount_with_apostrophe_separator: euros.replace(/\./g, "'") + "." + parts[1],
      amount_no_decimals_with_space_separator: eurosComma,
      amount_with_space_separator: eurosComma + "," + parts[1],
    };
    return String(format || "{{amount}}").replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
      return replacements[key] != null ? replacements[key] : replacements.amount;
    });
  }

  // Shopify geeft prijzen als integer cents. Gebruik de actieve shop/currency format
  // zodat EUR/SEK in cart drawer hetzelfde blijft als op de rest van de site.
  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return "";
    var settings = (window.themeVariables && window.themeVariables.settings) || {};
    var format = settings.currencyCodeEnabled
      ? settings.moneyWithCurrencyFormat
      : settings.moneyFormat;
    return formatWithShopifyMoneyFormat(cents, format);
  }

  function interpolate(template, values) {
    var out = template || "";
    Object.keys(values || {}).forEach(function (key) {
      out = out.replace(new RegExp("\\[" + key + "\\]", "g"), values[key]);
    });
    return out;
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function getLineProperty(item, name) {
    var props = (item && item.properties) || {};
    if (!props) return "";
    if (Object.prototype.hasOwnProperty.call(props, name)) return props[name];
    return "";
  }

  function isCartGiftLine(item) {
    return String(getLineProperty(item, "_oduree_gift") || "").toLowerCase() === "true";
  }

  function getCartItemHandle(item) {
    var handle = String((item && (item.handle || item.product_handle)) || "").toLowerCase();
    if (handle) return handle;

    var url = String((item && item.url) || "").toLowerCase();
    var match = url.match(/\/products\/([^/?#]+)/);
    return match && match[1] ? match[1] : "";
  }

  function isGiftTierLine(item) {
    var tierKey = String(getLineProperty(item, "_oduree_gift_tier") || "");
    return isCartGiftLine(item) && tierKey;
  }

  function copyValue(value, fallback) {
    if (!value || /translation missing/i.test(String(value))) return fallback;
    return value;
  }

  var CartDrawer = {
    _initialized: false,
    drawer: null,
    overlay: null,
    body: null,
    footer: null,

    init: function () {
      this.drawer = document.getElementById("cart-drawer");
      this.overlay = document.getElementById("cart-overlay");
      if (!this.drawer || !this.overlay) return;

      this.body = this.drawer.querySelector("[data-cart-body]");
      this._loadGiftTierSettings();
      this._applyCadeautjePanelOverride(0);

      // Custom element wrapper: voeg open()/close() toe aan <cart-drawer>
      // zodat legacy scripts blijven werken.
      if (this.drawer.open === undefined) {
        this.drawer.open = this.open.bind(this);
        this.drawer.close = this.close.bind(this);
        this.drawer.refresh = this.refresh.bind(this);
      }

      this._bindEvents();
      this._bindThemeEditorEvents();
      this._overrideTabLabels();
      this._overrideRewardAndGifts();
      this._enrichUpsellCompareAtPrices();
      this._initialized = true;

      // Pre-fetch product images voor gift tiers met een productHandle.
      this._loadGiftImages();

      // Bij page-load direct gift tiers syncen, ook als de klant terugkomt
      // met een bestaande cart of een native Shopify add-to-cart flow.
      var self2 = this;
      setTimeout(function () {
        self2._syncGiftAndMaybeRefresh();
      }, 800);
    },

    _bindEvents: function () {
      var self = this;

      // Overlay klik = close
      this.overlay.addEventListener("click", function () {
        self.close();
      });

      // ESC = close
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && self.isOpen()) self.close();
      });

      // Event-delegation voor [data-cart-close], [data-cart-qty], [data-cart-remove],
      // [data-upsell-add] en discount-form. Delegatie in document zodat re-render
      // (innerHTML swap) geen event-listeners verliest.
      document.addEventListener("click", function (e) {
        var el;

        // Sluit
        if ((el = e.target.closest("[data-cart-close]"))) {
          e.preventDefault();
          self.close();
          return;
        }

        // Qty +/-
        // Muteren op de regel-key (data-key) als die er is: scripts die
        // regels toevoegen (cadeaus, kraskaart-sleutelhanger) verschuiven de
        // regelindex, en dan zou een klik op index de verkeerde regel raken.
        if ((el = e.target.closest("[data-cart-qty]"))) {
          e.preventDefault();
          var line = parseInt(el.getAttribute("data-line"), 10);
          var item = el.closest("[data-cart-item]");
          var currentQty =
            parseInt(item && item.getAttribute("data-qty"), 10) || 1;
          var delta = el.getAttribute("data-cart-qty") === "+" ? 1 : -1;
          var newQty = Math.max(0, currentQty + delta);
          self._changeLine(line, newQty, item && item.getAttribute("data-key"));
          return;
        }

        // Verwijder
        if ((el = e.target.closest("[data-cart-remove]"))) {
          e.preventDefault();
          var removeLine = parseInt(el.getAttribute("data-cart-remove"), 10);
          var removeItem = el.closest("[data-cart-item]");
          self._changeLine(removeLine, 0, removeItem && removeItem.getAttribute("data-key"));
          return;
        }
        // Upsell toevoegen
        if ((el = e.target.closest("[data-upsell-add]"))) {
          e.preventDefault();
          var variantId = el.getAttribute("data-variant-id");
          var original = el.textContent;
          el.textContent = "...";
          el.disabled = true;
          self
            ._addToCart(variantId, 1)
            .then(function () {
              el.textContent = CART_T.addedSuccess || "Added";
              setTimeout(function () {
                el.textContent = original;
                el.disabled = false;
              }, 1200);
            })
            .catch(function () {
              el.textContent = CART_T.genericError || "Error";
              setTimeout(function () {
                el.textContent = original;
                el.disabled = false;
              }, 1200);
            });
          return;
        }
      });

      // Tab switching (header tabs: Winkelwagen / Cadeautje)
      // Schakelt zichtbaarheid tussen cart-body en cart-gift-panel. Actieve
      // tab krijgt .is-active (gouden onderstreping via CSS). Body wordt
      // via inline style display:none gezet omdat het via CSS alleen
      // overridden wordt (scope blijft zo scherp).
      document.addEventListener("click", function (e) {
        var tab = e.target.closest("[data-cart-tab]");
        if (!tab) return;
        var which = tab.getAttribute("data-cart-tab");
        var drawer = tab.closest("[data-cart-drawer]");
        if (!drawer) return;
        drawer.querySelectorAll("[data-cart-tab]").forEach(function (t) {
          t.classList.toggle("is-active", t === tab);
        });
        var body = drawer.querySelector("[data-cart-body]");
        var panel = drawer.querySelector("#cart-gift-panel");
        if (which === "gifts") {
          if (body) body.style.display = "none";
          if (panel) {
            panel.classList.add("is-active");
            panel.setAttribute("aria-hidden", "false");
          }
        } else {
          if (body) body.style.display = "";
          if (panel) {
            panel.classList.remove("is-active");
            panel.setAttribute("aria-hidden", "true");
          }
        }
      });

      // Kortingscode verwijderen - klik op het kruisje in de applied-chip.
      // Stuurt lege discount-string naar /cart/update.js wat alle codes wist.
      document.addEventListener("click", function (e) {
        var rm = e.target.closest("[data-discount-remove]");
        if (!rm) return;
        e.preventDefault();
        rm.disabled = true;
        var chip = rm.closest("[data-discount-applied]");
        if (chip) chip.classList.add("is-removing");

        fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ discount: "" }),
        })
          .then(function () {
            return CartDrawer.refresh();
          })
          .catch(function (err) {
            console.error("[CartDrawer] discount remove error", err);
            rm.disabled = false;
            if (chip) chip.classList.remove("is-removing");
          });
      });

      // Kortingscode submit - past discount AJAX toe, blijft in drawer.
      // Via /cart/update.js { discount: "CODE" } ondersteund sinds Shopify 2022.
      // Replace-semantiek: lege string wist alle codes, komma-separated list
      // vervangt alle bestaande codes met de nieuwe set.
      document.addEventListener("submit", function (e) {
        var form = e.target.closest("[data-cart-coupon]");
        if (!form) return;
        e.preventDefault();

        var input = form.querySelector('[name="discount"]');
        var btn = form.querySelector('button[type="submit"]');
        var code = ((input && input.value) || "").trim();
        if (!code) return;

        var originalLabel = btn ? btn.textContent : (CART_T.couponApply || "Apply");
        if (btn) {
          btn.disabled = true;
          btn.textContent = CART_T.couponApplying || "Applying...";
        }
        form.classList.remove("is-error", "is-success");

        fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ discount: code }),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            // Kraskaartcode (SLEUTELHANGER): Shopify meldt die pas "applicable"
            // zodra de sleutelhanger in de cart ligt, en die wordt juist door
            // het kraskaart-script toegevoegd. Dus: code staat op de cart maar
            // is nog niet applicable -> eerst het script laten syncen, daarna
            // de cart opnieuw lezen en pas dan oordelen.
            var codes0 = (cart && cart.discount_codes) || [];
            var present = codes0.some(function (c) {
              return c && c.code && c.code.toLowerCase() === code.toLowerCase();
            });
            var applicable0 = codes0.some(function (c) {
              return c && c.code && c.code.toLowerCase() === code.toLowerCase() && c.applicable;
            });
            if (present && !applicable0 && window.OdureeKraskaart && typeof window.OdureeKraskaart.sync === "function") {
              return window.OdureeKraskaart.sync()
                .then(function () {
                  return fetch("/cart.js", { cache: "no-store", headers: { Accept: "application/json" } });
                })
                .then(function (r2) { return r2.json(); })
                .catch(function () { return cart; });
            }
            return cart;
          })
          .then(function (cart) {
            // Check of Shopify de code als "applicable" markeert
            var codes = (cart && cart.discount_codes) || [];
            var applied = codes.some(function (c) {
              return (
                c &&
                c.code &&
                c.code.toLowerCase() === code.toLowerCase() &&
                c.applicable
              );
            });

            if (applied) {
              form.classList.add("is-success");
              if (input) input.value = "";
              return CartDrawer.refresh().then(function () {
                // Re-locate knop na refresh (innerHTML swap)
                var newBtn = document.querySelector(
                  "[data-cart-coupon] button[type=submit]"
                );
                if (newBtn) {
                  newBtn.textContent = CART_T.couponApplied || "Applied";
                  setTimeout(function () {
                    newBtn.textContent = originalLabel;
                    newBtn.disabled = false;
                  }, 1800);
                }
              });
            }

            // Code ongeldig of niet toepasbaar
            form.classList.add("is-error");
            if (btn) {
              btn.textContent = CART_T.couponInvalid || "Invalid code";
              setTimeout(function () {
                btn.textContent = originalLabel;
                btn.disabled = false;
                form.classList.remove("is-error");
              }, 2200);
            }
          })
          .catch(function (err) {
            console.error("[CartDrawer] discount apply error", err);
            form.classList.add("is-error");
            if (btn) {
              btn.textContent = CART_T.couponError || "Error";
              setTimeout(function () {
                btn.textContent = originalLabel;
                btn.disabled = false;
                form.classList.remove("is-error");
              }, 2200);
            }
          });
      });

      // Custom events vanuit andere secties
      document.addEventListener("cart:open", function () {
        self.open();
      });
      document.addEventListener("cart:refresh", function () {
        self.refresh();
      });
      document.addEventListener("cart:update", function () {
        self.refresh();
      });

      // Native Shopify add-to-cart events lopen soms buiten onze eigen events.
      var onNativeAdd = function () {
        self.refresh().then(function () { self.open(); });
      };
      document.documentElement.addEventListener("variant:add", onNativeAdd);
      document.documentElement.addEventListener("cart:change", onNativeAdd);

      // --- Cart-link interceptor ---
      // Vang elke klik op "/cart" (header-icon, mobile menu, etc.) op en open
      // de drawer ipv te navigeren naar de Shopify /cart-pagina. Uitzonderingen:
      //   * cmd/ctrl/shift-klik (user wil nieuwe tab openen)
      //   * links met data-force-cart-page (admin override)
      //   * links met target="_blank"
      //   * het checkout-pad /cart/checkout of /cart/add (blijven navigeren)
      document.addEventListener("click", function (e) {
        var link = e.target.closest("a[href]");
        if (!link) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        if (link.hasAttribute("data-force-cart-page")) return;
        if (link.target === "_blank") return;

        var url;
        try {
          url = new URL(link.href, window.location.origin);
        } catch (_) {
          return;
        }
        if (url.origin !== window.location.origin) return;

        // Match exact /cart (met optionele locale prefix zoals /nl/cart)
        var path = url.pathname.replace(/\/$/, "");
        var isCartPath = path === "/cart" || /\/cart$/.test(path);
        if (!isCartPath) return;

        e.preventDefault();
        self.refresh().then(function () {
          self.open();
        });
      });
    },

    _overrideTabLabels: function () {
      var drawer = this.drawer || document.getElementById("cart-drawer");
      if (!drawer) return;

      var cartTab = drawer.querySelector('[data-cart-tab="cart"]');
      var giftsTab = drawer.querySelector('[data-cart-tab="gifts"]');
      if (cartTab) {
        var count = cartTab.querySelector("[data-cart-count]");
        cartTab.childNodes.forEach(function (node) {
          if (node.nodeType === 3) node.nodeValue = "";
        });
        cartTab.insertBefore(
          document.createTextNode((CART_T.cart || "Cart") + " "),
          count || cartTab.firstChild,
        );
        if (count && count.parentNode !== cartTab) cartTab.appendChild(count);
      }
      if (giftsTab) {
        giftsTab.textContent = CART_T.gifts || CART_T.freeGifts || "Gifts";
        giftsTab.setAttribute(
          "aria-label",
          CART_T.freeGifts || CART_T.gifts || "Free gifts",
        );
      }
    },

    _bindThemeEditorEvents: function () {
      if (!(window.Shopify && window.Shopify.designMode)) return;
      if (this._themeEditorEventsBound) return;
      this._themeEditorEventsBound = true;

      var self = this;
      var rerender = function () {
        setTimeout(function () {
          self.drawer = document.getElementById("cart-drawer") || self.drawer;
          self.overlay = document.getElementById("cart-overlay") || self.overlay;
          self.body = self.drawer && self.drawer.querySelector("[data-cart-body]");
          self._loadGiftTierSettings();
          self._overrideRewardAndGifts();
          self._syncGiftAndMaybeRefresh();
        }, 120);
      };

      document.addEventListener("shopify:section:load", rerender);
      document.addEventListener("shopify:section:select", rerender);
      document.addEventListener("shopify:block:select", rerender);
      document.addEventListener("shopify:block:deselect", rerender);
    },

    // ---------- Open / close ----------
    isOpen: function () {
      return this.drawer && this.drawer.classList.contains("is-open");
    },

    open: function () {
      if (!this.drawer) return;
      this.drawer.classList.add("is-open");
      this.overlay.classList.add("is-open");
      this.drawer.setAttribute("aria-hidden", "false");
      this.overlay.setAttribute("aria-hidden", "false");
      document.body.classList.add("cart-drawer-open");
      document.body.style.overflow = "hidden";

      var self = this;
      setTimeout(function () {
        self._loadGiftTierSettings();
        self._overrideRewardAndGifts();
        self._syncGiftAndMaybeRefresh();
      }, 150);
    },

    close: function () {
      if (!this.drawer) return;
      this.drawer.classList.remove("is-open");
      this.overlay.classList.remove("is-open");
      this.drawer.setAttribute("aria-hidden", "true");
      this.overlay.setAttribute("aria-hidden", "true");
      document.body.classList.remove("cart-drawer-open");
      document.body.style.overflow = "";
    },

    // ---------- AJAX helpers ----------
    _addToCart: function (variantId, quantity) {
      var fd = new FormData();
      fd.append("id", variantId);
      fd.append("quantity", quantity || 1);
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: fd,
      })
        .then(function (r) {
          if (!r.ok) throw new Error("add failed");
          return r.json();
        })
        .then(function (res) {
          return CartDrawer.refresh().then(function () {
            return res;
          });
        });
    },

    _changeLine: function (line, quantity, key) {
      return fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(key ? { id: key, quantity: quantity } : { line: line, quantity: quantity }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error("change failed");
          return r.json();
        })
        .then(function () {
          return CartDrawer.refresh();
        });
    },

    // ---------- Dedupe duplicate cart lines ----------
    // Shopify MOET zelf mergen als variant_id + properties + selling_plan
    // identiek zijn, maar door third-party apps, race-conditions of
    // legacy line-properties kunnen er soms twee lines van hetzelfde
    // product in de cart komen. Deze helper voegt ze atomair samen
    // via /cart/update.js met de array-form van `updates`: we lezen alle
    // line-quantities uit, groeperen op identity-key, en zetten duplicates
    // terug naar 0 terwijl de eerste line de som van alle quantities krijgt.
    // Loopt bij elke refresh. Returnt { action:'deduped' } als er merged is
    // (zodat caller een extra UI-refresh kan doen), null als er niks te
    // doen was.
    _dedupeDuplicateLines: function () {
      return fetch("/cart.js", {
        cache: "no-store",
        headers: { Accept: "application/json" },
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart || !cart.items || cart.items.length < 2) return null;

          // Bouw identity-key per item. Twee lines met dezelfde key
          // betekent "echte duplicaten" en mogen samengevoegd worden.
          var groups = {};
          cart.items.forEach(function (item, idx) {
            var propsKey = JSON.stringify(item.properties || {});
            var spId = "";
            if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
              spId = String(item.selling_plan_allocation.selling_plan.id || "");
            }
            var key = String(item.variant_id) + "|" + propsKey + "|" + spId;
            if (!groups[key]) groups[key] = [];
            groups[key].push({ lineIndex: idx, qty: item.quantity });
          });

          // Start met huidige quantities; pas aan per duplicate-groep.
          var newQties = cart.items.map(function (it) { return it.quantity; });
          var hasChanges = false;
          Object.keys(groups).forEach(function (key) {
            var group = groups[key];
            if (group.length <= 1) return;
            hasChanges = true;
            var total = group.reduce(function (a, g) { return a + g.qty; }, 0);
            // Eerste line houdt het totaal, rest op 0.
            newQties[group[0].lineIndex] = total;
            for (var i = 1; i < group.length; i++) {
              newQties[group[i].lineIndex] = 0;
            }
          });

          if (!hasChanges) return null;
          console.info("[CartDrawer] Duplicate cart lines gedetecteerd, samenvoegen...", newQties);
          return fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ updates: newQties }),
          }).then(function (r) {
            return r.ok ? { action: "deduped" } : null;
          });
        })
        .catch(function (err) {
          console.warn("[CartDrawer] dedupe error", err);
          return null;
        });
    },

    _loadGiftTierSettings: function () {
      var source = this.drawer && this.drawer.querySelector("[data-oduree-gift-tiers]");
      var tiers = [];
      if (source && source.textContent) {
        try {
          tiers = JSON.parse(source.textContent) || [];
        } catch (err) {
          console.warn("[CartDrawer] gift tier config kon niet gelezen worden", err);
        }
      }
      if ((!tiers || !tiers.length) && window.ODUREE_GIFT_TIERS && window.ODUREE_GIFT_TIERS.length) {
        tiers = window.ODUREE_GIFT_TIERS;
        if (source) source.textContent = JSON.stringify(tiers);
      }

      GIFT_TIERS = tiers
        .filter(function (tier) {
          var handle = String((tier && tier.productHandle) || "").toLowerCase();
          return tier &&
            tier.enabled &&
            parseInt(tier.threshold, 10) > 0 &&
            PAUSED_GIFT_HANDLES.indexOf(handle) === -1;
        })
        .map(function (tier, idx) {
          return {
            key: String(tier.key || ("gift-" + idx)),
            threshold: toPresentmentCents(tier.threshold),
            label: tier.label || ("Gift " + (idx + 1)),
            desc: tier.desc || "",
            productHandle: tier.productHandle || "",
            variantId: tier.variantId ? String(tier.variantId) : "",
            image: tier.image || "",
            type: "gift",
          };
        })
        .sort(function (a, b) { return a.threshold - b.threshold; });

      MILESTONES = GIFT_TIERS.length ? GIFT_TIERS.slice() : FALLBACK_MILESTONES.slice();
      return GIFT_TIERS;
    },

    // ---------- Dynamische gift tiers ----------
    // Sync de cadeauproducten die in de theme customizer als Gift tier block staan.
    _resolveGiftTierVariants: function (tiers) {
      var missing = (tiers || []).filter(function (tier) {
        return tier && !tier.variantId && tier.productHandle;
      });
      if (!missing.length) return Promise.resolve(tiers);

      var lookups = missing.map(function (tier) {
        return fetch("/products/" + tier.productHandle + ".js", {
          cache: "no-store",
          headers: { Accept: "application/json" },
        })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (product) {
            if (!product || !product.variants || !product.variants.length) return;
            var variant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
            if (variant && variant.id) tier.variantId = String(variant.id);
            if ((!tier.label || /^Gift \d+$/.test(tier.label)) && product.title) tier.label = product.title;
            if (!tier.image && product.featured_image) {
              tier.image = product.featured_image;
              _giftImageCache[tier.productHandle] = product.featured_image;
            }
          })
          .catch(function () {});
      });

      return Promise.all(lookups).then(function () {
        MILESTONES = GIFT_TIERS.length ? GIFT_TIERS.slice() : FALLBACK_MILESTONES.slice();
        return tiers;
      });
    },

    _syncGiftAndMaybeRefresh: function () {
      var self = this;
      // GUARD: Oduree Gifts App is actief (shop metafield gevuld) die
      if (self._giftSyncInProgress) return Promise.resolve();
      self._giftSyncInProgress = true;
      self._loadGiftTierSettings();
      return self._syncGiftTiers().then(function (res) {
        self._giftSyncInProgress = false;
        // Null = geen wijziging; object = cart is veranderd re-render
        if (res && !self._giftSyncInProgress) {
          return self.refresh();
        }
      }).catch(function (err) {
        self._giftSyncInProgress = false;
        console.warn("[CartDrawer] gift sync error", err);
      });
    },

    _syncGiftTiers: function () {
      var self = this;
      var tiers = this._loadGiftTierSettings();
      return self._resolveGiftTierVariants(tiers).then(function (resolvedTiers) {
        var giftTiersWithVariants = resolvedTiers.filter(function (tier) {
          return tier.variantId;
        });

        return fetch("/cart.js", { cache: "no-store", headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart || !cart.items) return null;

          var qualifyingTotal = 0;
          var giftLinesByVariant = {};
          cart.items.forEach(function (item) {
            if (isGiftTierLine(item)) {
              var vid = String(item.variant_id);
              if (!giftLinesByVariant[vid]) giftLinesByVariant[vid] = [];
              giftLinesByVariant[vid].push({
                key: item.key,
                quantity: item.quantity,
              });
            } else {
              qualifyingTotal += item.final_line_price || 0;
            }
          });

          var desired = {};
          giftTiersWithVariants.forEach(function (tier) {
            if (qualifyingTotal >= tier.threshold) desired[String(tier.variantId)] = tier;
          });

          var changes = [];
          Object.keys(giftLinesByVariant).forEach(function (variantId) {
            var lines = giftLinesByVariant[variantId];
            if (!desired[variantId]) {
              lines.forEach(function (line) {
                changes.push({ id: line.key, quantity: 0 });
              });
              return;
            }

            lines.forEach(function (line, idx) {
              var targetQty = idx === 0 ? 1 : 0;
              if (line.quantity !== targetQty) {
                changes.push({ id: line.key, quantity: targetQty });
              }
            });
          });

          var toAdd = Object.keys(desired)
            .filter(function (variantId) {
              return !giftLinesByVariant[variantId] || !giftLinesByVariant[variantId].length;
            })
            .map(function (variantId) {
              var tier = desired[variantId];
              return {
                id: variantId,
                quantity: 1,
                properties: {
                  _oduree_gift: "true",
                  _oduree_gift_tier: tier.key,
                  _oduree_gift_label: tier.label,
                  _oduree_gift_threshold: String(tier.threshold),
                },
              };
            });

          var chain = Promise.resolve();
          changes.forEach(function (change) {
            chain = chain.then(function () {
              return fetch("/cart/change.js", {
                method: "POST",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                body: JSON.stringify(change),
              });
            });
          });

          if (toAdd.length) {
            chain = chain.then(function () {
              return fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                body: JSON.stringify({ items: toAdd }),
              });
            });
          }

          if (!changes.length && !toAdd.length) return null;
          return chain.then(function () { return { action: "gift-tiers-synced" }; });
        });
      });
    },

    // Laadt product-data voor elke milestone met productHandle en cachet
    // de featured_image URL. Na load: roept refresh() aan zodat het paneel
    // opnieuw rendert met de echte thumbnail (vervangt SVG-fallback).
    _loadGiftImages: function () {
      var self = this;
      this._loadGiftTierSettings();
      MILESTONES.forEach(function (m) {
        if (m.productHandle && m.image) _giftImageCache[m.productHandle] = m.image;
      });
      var handles = MILESTONES
        .filter(function (m) { return m.productHandle; })
        .map(function (m) { return m.productHandle; });
      if (!handles.length) return Promise.resolve();
      var promises = handles.map(function (h) {
        if (_giftImageCache[h]) return Promise.resolve(_giftImageCache[h]);
        return fetch("/products/" + h + ".js")
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            if (p && p.featured_image) {
              _giftImageCache[h] = p.featured_image;
            }
            return _giftImageCache[h] || null;
          })
          .catch(function () { return null; });
      });
      return Promise.all(promises).then(function () {
        // Re-render reward-bar + gift-paneel zodra image-data binnen is,
        // zodat de echte thumbnail de SVG-fallback vervangt. Werkt alleen
        // als drawer al geinitialiseerd is.
        if (self.drawer && typeof self._overrideRewardAndGifts === "function") {
          self._overrideRewardAndGifts();
        }
      });
    },

    // ---------- MILESTONES OVERLAY (JS-workaround voor liquid sync-lag) ----------
    // Overrulet de reward-bar tekst/progress/ticks en vult het Cadeaus-
    // paneel aan met de juiste milestones (incl. Kaartenspel m4), onafhan-
    // kelijk van wat de server-side Liquid rendert. Idempotent - mag na
    // elke refresh opnieuw gedraaid worden.
    _overrideRewardAndGifts: function () {
      var drawer = this.drawer;
      if (!drawer) return;
      this._loadGiftTierSettings();

      // Haal cart_total op uit de DOM (data-cart-total) als beschikbaar -
      // anders async via cart.js. We gebruiken SYNCHRONOUS DOM-read zodat
      // de UI direct klopt; _updateWithCartTotal doet exact renderen.
      var totalEl = drawer.querySelector("[data-cart-total]");
      // Liquid rendert bv. "€ 71,75" - parse naar cents.
      var parsed = this._parseMoneyToCents(totalEl ? totalEl.textContent : "");
      var self = this;
      // Altijd async bevestigen via cart.js (betrouwbare bron).
      fetch("/cart.js", { cache: "no-store", headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          // Gift lines tellen niet mee voor de volgende drempel.
          var excludedGiftPrice = 0;
          cart.items.forEach(function (it) {
            if (isGiftTierLine(it)) {
              excludedGiftPrice += it.final_line_price || 0;
            }
          });
          var qualifyingTotal = (cart.total_price || 0) - excludedGiftPrice;
          if (qualifyingTotal < 0) qualifyingTotal = 0;
          self._applyRewardBarOverride(qualifyingTotal);
          self._applyCadeautjePanelOverride(qualifyingTotal);
        })
        .catch(function () {
          if (parsed != null) {
            self._applyRewardBarOverride(parsed);
            self._applyCadeautjePanelOverride(parsed);
          }
        });
    },

    _parseMoneyToCents: function (text) {
      if (!text) return null;
      // "€ 71,75" / "€71,75" / "EUR 71,75" 7175
      var clean = String(text).replace(/[^0-9,\.]/g, "").replace(",", ".");
      var num = parseFloat(clean);
      if (isNaN(num)) return null;
      return Math.round(num * 100);
    },

    _applyRewardBarOverride: function (cartTotal) {
      var drawer = this.drawer;
      if (!drawer) return;
      var bar = drawer.querySelector("[data-cart-shipping], .cart-reward-bar");
      if (!bar) return;

      // Simpele funnel:
      // 0-45: gratis verzending, 45-100: Signature Paraplu, 100+: beide.
      var shippingThreshold =
        (FALLBACK_MILESTONES[0] && FALLBACK_MILESTONES[0].threshold) ||
        toPresentmentCents(BASE_FREE_SHIPPING_THRESHOLD_CENTS);
      var giftMilestone = null;
      for (var gi = 0; gi < MILESTONES.length; gi++) {
        if (MILESTONES[gi].type === "gift") {
          giftMilestone = MILESTONES[gi];
          break;
        }
      }

      var maxT = giftMilestone ? giftMilestone.threshold : shippingThreshold;
      var progressPct = Math.min(100, (cartTotal * 100) / maxT);
      var next = null;
      if (cartTotal < shippingThreshold) {
        next = {
          threshold: shippingThreshold,
          label: CART_T.freeShippingLabel || "free shipping",
          type: "shipping",
        };
      } else if (giftMilestone && cartTotal < giftMilestone.threshold) {
        next = giftMilestone;
      }

      // Fill + is-complete class
      var fill = bar.querySelector("[data-ship-fill], .cart-reward-bar__fill");
      if (fill) fill.style.width = progressPct + "%";
      bar.classList.toggle("is-complete", !next);

      var textEl = bar.querySelector(".cart-reward-bar__text");
      if (textEl) {
        if (!next) {
          if (giftMilestone) {
            textEl.innerHTML = interpolate(
              copyValue(
                CART_T.tieredRewardsCompleteHtml,
                "You receive <strong>[shipping] + [gift]</strong>",
              ),
              {
                shipping: escapeHtml(CART_T.freeShippingLabel || "Free shipping"),
                gift: escapeHtml(giftMilestone.label),
              },
            );
          } else {
            textEl.innerHTML = CART_T.shippingUnlockedHtml || "You now have <strong>free shipping</strong>.";
          }
        } else if (next.type === "shipping") {
          textEl.innerHTML = interpolate(
            CART_T.shippingRemainingHtml || "<strong data-ship-amount>[amount]</strong> to go for <strong>free shipping</strong>",
            { amount: formatMoney(next.threshold - cartTotal), gift_hint: "" },
          );
        } else {
          textEl.innerHTML = interpolate(
            copyValue(CART_T.giftTierRemainingHtml, "[amount] to go for <strong>[reward]</strong>."),
            { amount: formatMoney(next.threshold - cartTotal), reward: escapeHtml(next.label) },
          );
        }
      }

      // Ticks: alleen de tussenstap op €45 tonen als er een €100 cadeau is.
      var track = bar.querySelector(".cart-reward-bar__track");
      if (track) {
        track.querySelectorAll(".cart-reward-bar__tick").forEach(function (t) {
          t.remove();
        });
        var tickThresholds = giftMilestone
          ? [shippingThreshold, giftMilestone.threshold]
          : [shippingThreshold];
        tickThresholds.forEach(function (th) {
          if (th <= 0 || th >= maxT) return;
          var pct = (th * 100) / maxT;
          var tick = document.createElement("div");
          tick.className = "cart-reward-bar__tick";
          tick.style.left = pct + "%";
          track.appendChild(tick);
        });
      }
    },

    _applyCadeautjePanelOverride: function (cartTotal) {
      var panel = this.drawer && this.drawer.querySelector("#cart-gift-panel");
      if (!panel) return;

      // Verwijder bestaande rijen en rebuild.
      panel.querySelectorAll(".cart-gift-item").forEach(function (el) { el.remove(); });

      var svgShipping =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<rect x="1" y="3" width="15" height="13" rx="1"/>' +
        '<path d="M16 8h4l3 5v3h-7V8z"/>' +
        '<circle cx="5.5" cy="18.5" r="2.5"/>' +
        '<circle cx="18.5" cy="18.5" r="2.5"/>' +
        "</svg>";
      var svgCard =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<rect x="4" y="2" width="12" height="18" rx="1.5"/>' +
        '<rect x="8" y="5" width="12" height="18" rx="1.5"/>' +
        "</svg>";
      var svgGift =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<polyline points="20 12 20 22 4 22 4 12"/>' +
        '<rect x="2" y="7" width="20" height="5"/>' +
        '<line x1="12" y1="22" x2="12" y2="7"/>' +
        '<path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/>' +
        '<path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>' +
        "</svg>";

      MILESTONES.forEach(function (m) {
        var reached = cartTotal >= m.threshold;
        var row = document.createElement("div");
        row.className = "cart-gift-item" + (reached ? "" : " is-locked");

        // Image-URL komt uit _giftImageCache (gevuld door _loadGiftImages).
        // Als nog niet geladen: fallback naar SVG-gift-icoon. Na load wordt
        // het paneel opnieuw gerenderd met echte thumbnail.
        var visualHtml = "";
        if (m.productHandle && _giftImageCache[m.productHandle]) {
          var src = _giftImageCache[m.productHandle];
          // Shopify image URLs starten met // - ondersteun ook absolute https.
          var sep = src.indexOf("?") === -1 ? "?" : "&";
          var imgUrl = src + sep + "width=120";
          visualHtml =
            '<div class="cart-gift-item__img">' +
            '<img src="' + imgUrl + '" alt="' + escapeHtml(m.label) + '" width="52" height="52" loading="lazy">' +
            "</div>";
        }
        if (!visualHtml) {
          var svg = m.key === "m2" ? svgShipping : (m.key === "m4" ? svgCard : svgGift);
          visualHtml = '<div class="cart-gift-item__icon">' + svg + "</div>";
        }

        var descHtml;
        if (reached) {
          if (m.type === "shipping" || m.key === "m2") {
            descHtml = CART_T.shippingUnlockedHtml || "You have <strong>free shipping</strong>!";
          } else {
            descHtml = interpolate(CART_T.genericUnlockedHtml || "Congratulations on your <strong>[reward]</strong>.", {
              reward: escapeHtml(m.label.toLowerCase()),
            });
          }
        } else {
          var remaining = m.threshold - cartTotal;
          var remainingHtml = "<strong>" + formatMoney(remaining) + "</strong>";
          if (m.type === "shipping" || m.key === "m2") {
            descHtml = interpolate(CART_T.shippingDescRemainingHtml || "Only [amount] away from <strong>free shipping</strong>.", {
              amount: remainingHtml,
            });
          } else {
            descHtml = interpolate(
              CART_T.giftTierRemainingHtml || CART_T.genericRemainingHtml || "Only [amount] away from <strong>[reward]</strong>.",
              { amount: remainingHtml, reward: escapeHtml(m.label) }
            );
          }
        }
        row.innerHTML =
          visualHtml +
          '<div class="cart-gift-item__info">' +
          '<p class="cart-gift-item__name">' + escapeHtml(m.label) + "</p>" +
          '<p class="cart-gift-item__desc">' + descHtml + "</p>" +
          '<span class="cart-gift-badge cart-gift-badge--' + (reached ? "unlocked" : "locked") + '">' +
          (reached ? (CART_T.unlocked || "Unlocked") : (CART_T.locked || "Not yet reached")) +
          "</span>" +
          "</div>";

        panel.appendChild(row);
      });
    },

    // Enrich upsell-cards met compare_at_price (doorgehaalde before-prijs).
    // Nodig omdat Liquid-sync vastzit en upsell-cards in sections/cart-drawer
    // .liquid geen compare_at_price renderen. Fetcht één keer per product-
    // handle de prijs-data, cachet client-side, en injecteert een <s>-element
    // boven de .upsell-card__price.
    _enrichUpsellCompareAtPrices: function () {
      var cards = this.drawer && this.drawer.querySelectorAll(".upsell-card");
      if (!cards || !cards.length) return;

      // Init cache globaal (overleeft refreshes binnen dezelfde pageload)
      if (!window._odureeUpsellProductCache) {
        window._odureeUpsellProductCache = {};
      }
      var cache = window._odureeUpsellProductCache;

      // Parse elke card: haal handle uit product-link (/products/HANDLE?...)
      // + variant-id uit de [data-upsell-add] knop.
      var byHandle = {};
      cards.forEach(function (card) {
        if (card.querySelector(".upsell-card__compare")) return; // al verwerkt
        var link = card.querySelector(".upsell-card__img");
        var href = link && link.getAttribute("href");
        if (!href) return;
        var m = href.match(/\/products\/([a-z0-9-]+)/i);
        if (!m) return;
        var handle = m[1];
        var btn = card.querySelector("[data-upsell-add]");
        var variantId = btn && btn.getAttribute("data-variant-id");
        if (!variantId) return;
        if (!byHandle[handle]) byHandle[handle] = [];
        byHandle[handle].push({ card: card, variantId: String(variantId) });
      });

      // Per unieke handle: fetch eenmaal, vervolgens injecteer compare-prijs
      // voor elke card van die handle.
      Object.keys(byHandle).forEach(function (handle) {
        var entries = byHandle[handle];
        var apply = function (product) {
          if (!product || !product.variants) return;
          var variantMap = {};
          product.variants.forEach(function (v) {
            variantMap[String(v.id)] = v;
          });
          entries.forEach(function (entry) {
            var v = variantMap[entry.variantId];
            if (!v) return;
            var compare = v.compare_at_price;
            var price = v.price;
            if (!compare || compare <= price) return;
            var priceEl = entry.card.querySelector(".upsell-card__price");
            if (!priceEl) return;
            if (entry.card.querySelector(".upsell-card__compare")) return;
            var compareEl = document.createElement("s");
            compareEl.className = "upsell-card__compare";
            compareEl.textContent = formatMoney(compare);
            priceEl.parentNode.insertBefore(compareEl, priceEl);
          });
        };

        if (cache[handle]) {
          apply(cache[handle]);
        } else {
          fetch("/products/" + handle + ".js")
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (p) {
              if (p) {
                cache[handle] = p;
                apply(p);
              }
            })
            .catch(function () {});
        }
      });
    },

    // ---------- Section refresh ----------
    // BELANGRIJK: cart-drawer zit in overlay-group.json als group-section.
    // Shopify's `/?sections=cart-drawer` API laadt GEEN section-group-settings,
    // waardoor customizer-instellingen uit overlay-group kunnen ontbreken.
    // Fix: vraag een volledige page op en extract #cart-drawer eruit.
    // Iets langzamer, maar behoudt alle section-group settings correct.
    refresh: function () {
      var self = this;
      return fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/") + "?cart_refresh=" + Date.now(), {
        headers: { Accept: "text/html" },
      })
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          if (!html) return;
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");

          // De section-rendering API retourneert de hele sectie (inclusief
          // wrapper-div). We zoeken in het geparseerde document naar een
          // nieuw <cart-drawer> en vervangen body + footer van onze drawer.
          var newDrawer = doc.getElementById("cart-drawer");
          if (!newDrawer) return;

          // Behoud is-open class maar vervang inner
          var wasOpen = self.isOpen();
          self.drawer.innerHTML = newDrawer.innerHTML;
          if (wasOpen) self.drawer.classList.add("is-open");

          // Re-assign body ref (het is een nieuwe DOM-node)
          self.body = self.drawer.querySelector("[data-cart-body]");

          // Fix tab-labels (Cadeautje Cadeaus) tot Liquid sync doorkomt.
          self._overrideTabLabels();

          // Overrule reward-bar tekst/progress/ticks en rebuild het
          // Cadeaus-paneel vanuit de dynamische gift tiers.
          self._overrideRewardAndGifts();

          // Doorgestreepte before-prijs op upsell-cards.
          self._enrichUpsellCompareAtPrices();
          // Na elke refresh: sync de dynamische gift tiers.
          self._syncGiftAndMaybeRefresh();

          // Update cart count in navigatie (header-badge)
          var newCountEl = newDrawer.querySelector("[data-cart-count]");
          var newCount = newCountEl
            ? parseInt(newCountEl.textContent.replace(/[^0-9]/g, ""), 10)
            : 0;
          CartDrawer.updateNavBadge(newCount);

          // Broadcast zodat andere UI-componenten (PDP reward-bar, etc.)
          // kunnen meesynchroniseren. Zonder dit blijft bijv. de shipping/gift
          // bar op de productpagina de oude state tonen wanneer klant items
          // via de drawer qty-controls of remove-knop wijzigt.
          document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));
        })
        .catch(function (e) {
          console.warn("[CartDrawer] refresh error", e);
        });
    },

    // Update cart-count badges buiten de drawer (header, mobiele knop, etc.)
    updateNavBadge: function (count) {
      document
        .querySelectorAll(
          "[data-cart-count-global], .cart-count, .nav-cart-badge, [data-header-cart-count]",
        )
        .forEach(function (el) {
          if (
            el.classList.contains("nav-cart-badge") ||
            el.hasAttribute("data-header-cart-count")
          ) {
            el.textContent = count;
            el.style.display = count > 0 ? "" : "none";
          } else {
            el.textContent = "(" + count + ")";
          }
        });
    },
  };

  // ---------- ATC interceptor voor formulieren ----------
  // Vangt alle submits op /cart/add forms op, doet AJAX-add en opent de drawer.
  // Oduree eigen PDP + product-card gebruiken al eigen AJAX (en dispatchen
  // cart:refresh) - deze interceptor is voor generieke Shopify-forms.
  document.addEventListener("submit", function (e) {
    var form = e.target.closest(
      'form[action$="/cart/add"], form[action$="/cart/add.js"]',
    );
    if (!form) return;

    // Skip als een andere handler het al overneemt (bijv. oduree-quick-add)
    if (form.hasAttribute("data-oduree-quick-add")) return;
    if (form.hasAttribute("data-atc-form")) return;

    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var originalText = btn ? btn.textContent : "";
    if (btn) {
      btn.disabled = true;
      btn.textContent = "...";
    }

    var fd = new FormData(form);
    fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: fd,
    })
      .then(function (r) {
        if (!r.ok) throw new Error("add failed");
        return r.json();
      })
      .then(function () {
        return CartDrawer.refresh();
      })
      .then(function () {
        CartDrawer.open();
        if (btn) {
          btn.textContent = CART_T.addedSuccess || "Added!";
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1500);
        }
      })
      .catch(function (err) {
        console.error("[CartDrawer] add error", err);
        if (btn) {
          btn.textContent = originalText;
          btn.disabled = false;
        }
      });
  });

  // ---------- Auto-open trigger via ?open_cart=1 of #cart ----------
  // Bronnen:
  //   * /cart redirect uit layout/theme.liquid /?open_cart=1
  //   * Externe/directe links naar /#cart
  // We verwijderen de marker uit de URL zodat hij niet blijft hangen bij
  // page-reload, back-nav, bookmark of Core Web Vitals tooling.
  function autoOpenFromUrl() {
    var url = new URL(window.location.href);
    var shouldOpen = url.searchParams.get("open_cart") === "1" || url.hash === "#cart";
    if (!shouldOpen) return;

    // Strip marker uit URL (geen reload)
    url.searchParams.delete("open_cart");
    if (url.hash === "#cart") url.hash = "";
    var cleanUrl = url.pathname + (url.search ? url.search : "") + (url.hash || "");
    window.history.replaceState({}, document.title, cleanUrl);

    // Open drawer zodra hij klaar is + refresh zodat cleanup-script z'n werk
    // heeft kunnen doen (verzekerde-verzending verwijderen).
    var openWhenReady = function () {
      if (window.CartDrawer && typeof window.CartDrawer.refresh === "function") {
        window.CartDrawer.refresh().then(function () {
          window.CartDrawer.open();
        });
      } else {
        document.dispatchEvent(new CustomEvent("cart:open"));
      }
    };
    // Kleine delay zodat cleanup in assets/custom.js eerst mag lopen
    setTimeout(openWhenReady, 150);
  }

  // Expose global before init so inline Shopify/theme bridges can still
  // reach the controller if a later init step throws.
  window.CartDrawer = CartDrawer;

  // Init zodra DOM beschikbaar is
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      CartDrawer.init();
      autoOpenFromUrl();
    });
  } else {
    CartDrawer.init();
    autoOpenFromUrl();
  }

})();
